export const RollingPeriodUnit = Object.freeze({
    Hours: 0,
    Days: 1,
});
